import Link from "next/link";

export function Logo() {
  return (
    <Link title="Freepik Image Downloader" href="/" className=" font-bold">
      <span className="hidden sm:block"> Freepik Downloader.</span>
      <span className="block sm:hidden uppercase">FD.</span>
    </Link>
  );
}
